<template>
  <div class="card floating" id="cancel-subscription">
    <div class="title">
      <frown-icon size="1.5x" class="custom-class"></frown-icon>
      <h2>{{ $t('prompts.wantCancel') }}</h2>
    </div>
    <p v-html="$t('prompts.confirmCancelSubscription')"></p>
    <div style="position: relative; padding: 0;">
      <div class="campo">
        <p>{{ optionSelected }}</p>
        <chevron-down-icon size="1.5x" class="chevron" @click="isShow = !isShow"></chevron-down-icon>
      </div>
      <nav id="menu-desplegable" :style="menuStyle">
        <div style="display: block; border: none; text-align: left;">
          <button v-for="(option) in options" :key="option" :title="option" :aria-label="option" @click="cambioOpcion(option)" type="button">
            <p>{{ option }}</p>
          </button>
        </div>
      </nav>
    </div>
    <textarea v-if="optionSelected.includes('*')" class="input input--block" type="text" :placeholder="placeholder" v-model.trim="comment" rows="5"></textarea>
    <div class="botones">
      <button v-if="$route.name === 'Plans'" @click="changePlan()" :aria-label="$t('prompts.choosePlan')" :title="$t('prompts.choosePlan')" id="choose-plan-button">
        <span>{{ $t('prompts.choosePlan') }}</span>
      </button>
      <button v-else @click="$store.commit('closeHovers')" :aria-label="$t('prompts.keepAccount')" :title="$t('prompts.keepAccount')" id="choose-plan-button">
        <span>{{ $t('prompts.keepAccount') }}</span>
      </button>
      <button @click="logout" :aria-label="$t('prompts.cancelSubscription')" :title="$t('prompts.cancelSubscription')" id="cancel-subscription-button" :disabled="disabledCancel">
        <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
        <span>{{ $t('prompts.cancelSubscription') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import * as auth from '@/utils/auth';
import { FrownIcon, Trash2Icon, ChevronDownIcon } from 'vue-feather-icons';
import i18n from '@/i18n';

export default {
  name: 'cancel-subscription',
  components: {
    FrownIcon,
    Trash2Icon,
    ChevronDownIcon
  },
  data: function () {
    return {
      options: [],
      optionSelected: '',
      isShow: false,
      placeholder: '',
      comment: ''
    };
  },
  mounted () {
    this.options = [i18n.t('prompts.privacyNotImportant'), i18n.t('prompts.payService'), i18n.t('prompts.subscriptionHigh'), i18n.t('prompts.technicalProblems'), i18n.t('prompts.lacksServices'), i18n.t('prompts.anotherReason')];
    this.optionSelected = i18n.t('prompts.privacyNotImportant');
  },
  watch: {
    optionSelected (val) {
      if (val === i18n.t('prompts.technicalProblems')) {
        this.placeholder = i18n.t('prompts.which');
      } else if (val === i18n.t('prompts.lacksServices')) {
        this.placeholder = i18n.t('prompts.servicesNeed');
      } else if (val === i18n.t('prompts.anotherReason')) {
        this.placeholder = i18n.t('prompts.which2');
      } 
    }
  },
  computed: {
    menuStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
    disabledCancel() {
      if ((this.optionSelected === i18n.t('prompts.technicalProblems') || this.optionSelected === i18n.t('prompts.lacksServices') || this.optionSelected === i18n.t('prompts.anotherReason')) && this.comment === '') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations(['closeHovers']),
    cambioOpcion (opcion) {
      this.optionSelected = opcion;
      this.isShow = false;
    },
    async logout() {
      let action = await ibb.getAccountInfo();
      if (action.error.type) {
        throw new Error('Error getting account info: ' + action.error.type);
      }
      let handle = action.accountInfo.handle;
      let reason = '';
      if (this.comment !== '') {
        reason = this.optionSelected.replace('*', '') + '- ' + this.comment;
      } else {
        reason = this.optionSelected;
      }
      await auth.deleteAccount(handle, reason);
      this.$store.commit('closeHovers');
    },
    changePlan() {
      this.$store.commit('closeHovers');
      this.$store.commit('showHover', 'change-plan');
    }
  }
};
</script>